import React from "react";
import { ExternalLink } from "lucide-react";
import { useQuote } from "../QuoteDialog";

export default function FinishingCTA() {
  const { openQuote } = useQuote();
  return (
    <section
      data-testid="finishing-cta-section"
      className="relative bg-navy text-white py-24 md:py-32 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      <div className="absolute -bottom-32 -left-20 w-96 h-96 bg-teal/30 rounded-full blur-3xl" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 lg:px-16 text-center">
        <h2
          data-testid="finishing-cta-headline"
          className="font-serif text-3xl sm:text-4xl lg:text-6xl font-black tracking-tight text-white leading-[1.1]"
        >
          Complete Your School's{" "}
          <span className="text-teal">Print Setup.</span>
        </h2>
        <p className="mt-8 text-lg sm:text-xl text-slate-200 max-w-2xl mx-auto leading-relaxed">
          Tell us what your school needs, and we'll recommend the right
          combination of tools.
        </p>
        <div className="mt-10">
          <button
            data-testid="finishing-cta-quote-btn"
            onClick={openQuote}
            title="Opens in a new tab"
            className="group inline-flex items-center justify-center gap-2 bg-teal hover:bg-[#0D6BB1] text-white font-bold px-8 py-4 rounded-lg shadow-xl transition-all duration-200 hover:-translate-y-0.5"
          >
            Request a Quote
            <ExternalLink className="w-5 h-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </section>
  );
}
